import {
  SubjectivitySearchResponse,
  SubjectivitySearchRequestQuery,
  SubjectivityUpdateRequestBody,
} from '@lio/api-types';
import { ArrayItem } from '@utils/commonTypes';

export type SubjectivityItem = ArrayItem<SubjectivitySearchResponse['items']>;

export const getSubjectivitiesQuery = ({
  quoteId,
  policyId,
  sort,
  quoteType,
  pageOffset,
  pageLimit,
}: SubjectivitySearchRequestQuery & Partial<SubjectivityUpdateRequestBody>) => {
  const query = new URLSearchParams();
  if (pageLimit !== undefined) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset !== undefined) {
    query.append('pageOffset', String(pageOffset));
  }
  // Default to newest-first so a renewal's new subjectivities aren't buried below
  // existing ones on later pages (LIO-30052).
  query.append('sort', sort ? sort.toString() : '-createdAt');
  if (quoteId) {
    query.append('quoteId', quoteId);
  }
  if (policyId) {
    query.append('policyId', policyId);
  }
  if (quoteType) {
    query.append('quoteType', quoteType);
  }
  return query.toString();
};
